import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useState } from 'react';
import TabContent from './TabContent';
import Tab from './Tab';
import { mapChildren } from '../../../utils';
var TabContext = createContext({});
export function useTabs() {
    return useContext(TabContext);
}
export var TabControl = function (_a) {
    var currentTab = _a.currentTab, onTabClick = _a.onTabClick, children = _a.children, tabType = _a.tabType, deps = _a.deps, noErrors = _a.noErrors;
    var _b = useState(0), _activeTab = _b[0], setActiveTab = _b[1];
    var tabElementType = tabType !== null && tabType !== void 0 ? tabType : Tab;
    var isTabType = function (child) {
        return child.type === tabElementType || child.type === TabContent;
    };
    var activeTab = currentTab !== null && currentTab !== void 0 ? currentTab : _activeTab;
    var onTabElementClick = function (tab) {
        if (onTabClick) {
            onTabClick(tab);
        }
        else {
            setActiveTab(tab);
        }
    };
    // Don't render tabcontent on initial render, but after rendered once, only hide it and don't set the children on null
    var parseChildren = function () {
        var tabIndex = 0;
        var tabContentIndex = 0;
        var parsedChildren = mapChildren(children, isTabType, (function (child) {
            if (child.type === tabElementType) {
                var tab = React.cloneElement(child, {
                    active: tabIndex === activeTab,
                    index: tabIndex,
                    onClick: onTabElementClick
                });
                tabIndex++;
                return tab;
            }
            var currentIndex = tabContentIndex;
            var tabContentProps = {
                active: tabContentIndex === activeTab,
                index: tabContentIndex,
                setActiveTab: onTabElementClick,
                next: function () {
                    onTabElementClick(currentIndex + 1);
                },
                previous: function () {
                    onTabElementClick(currentIndex - 1);
                },
            };
            var tabContent;
            if (tabContentIndex === activeTab) {
                tabContent = React.cloneElement(child, tabContentProps);
            }
            else {
                tabContent = React.createElement(child.type, tabContentProps);
            }
            tabContentIndex++;
            return tabContent;
        }));
        if (tabIndex !== tabContentIndex && !noErrors) {
            throw 'Tab count must equal the amount of tab contents!';
        }
        return parsedChildren;
    };
    var parsedChildren = parseChildren();
    return (_jsx(React.Fragment, { children: parsedChildren }));
};
export default TabControl;
